import { useEffect } from "react";
import useAnalyticsBeacon from "../hooks/useAnalyticsBeacon";
import { isAnalyticsEnabled } from "../lib/analyticsBeacon";

/**
 * Mount once at the App level (inside BrowserRouter).
 *
 *  - Fires our in-house `page_view` beacon on every customer route change.
 *  - Conditionally injects the Cloudflare Web Analytics beacon script —
 *    only on production hostnames, so preview/localhost traffic does NOT
 *    pollute Cloudflare's traffic dashboard.
 *
 * Renders nothing.
 */

const CLOUDFLARE_BEACON_TOKEN = "b69a80d3b22240408e213ecfa4faecc2";

export default function AnalyticsBeacon() {
    useAnalyticsBeacon();

    useEffect(() => {
        if (!isAnalyticsEnabled()) return;
        if (typeof document === "undefined") return;
        if (document.querySelector("script[data-cf-beacon]")) return;
        try {
            const s = document.createElement("script");
            s.defer = true;
            s.src = "https://static.cloudflareinsights.com/beacon.min.js";
            s.setAttribute("data-cf-beacon", JSON.stringify({ token: CLOUDFLARE_BEACON_TOKEN }));
            document.head.appendChild(s);
        } catch { /* never break the app for analytics */ }
    }, []);

    return null;
}
